const TopSection = () => {
  const features = [
    {
      icon: 'ri-time-line',
      title: '年中無休・深夜24時まで対応',
      description: '午前9時から深夜24時まで、年中無休（不定休）で対応いたします。お忙しい方でも安心してご相談いただけます。',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'リーズナブルな料金設定',
      description: '明確で分かりやすい料金体系。他事務所と比較しても圧倒的にリーズナブルな価格でサービスを提供いたします。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '豊富な実績と高い許可率',
      description: '特定技能ビザ申請の豊富な経験と実績。確実な申請サポートで、お客様の在留資格取得をサポートいたします。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '丁寧なサポート体制',
      description: '申請書類の作成から入管への申請まで、一貫してサポート。お客様の状況に合わせた最適なアドバイスを提供します。',
    }
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-8">

        {/* セクションヘッダー */}
        <div className="flex items-start gap-6 mb-16">
          <div className="flex-shrink-0 pt-1">
            <div className="w-px h-16 bg-[#1a3a5c]"></div>
          </div>
          <div>
            <p className="text-[#1a3a5c] text-xs tracking-[0.3em] font-medium uppercase mb-2">Our Strengths</p>
            <h2
              className="text-5xl font-bold text-slate-800 mb-3"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              当事務所の特徴
            </h2>
            <p className="text-slate-500 text-base">行政書士ＭＫ法務事務所が選ばれる理由</p>
          </div>
        </div>

        {/* 写真＋特徴 レイアウト */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16 items-center">
          {/* 左：写真 */}
          <div className="relative">
            <div className="w-full h-[420px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/6b45eeb106b12d9fb23bb4e2435b6e0d.jpg"
                alt="行政書士 専門家"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* 装飾フレーム */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-[#1a3a5c]/30 -z-10"></div>
            {/* 資格バッジ */}
            <div className="absolute bottom-6 left-6 bg-[#0a1f3a]/90 backdrop-blur-sm px-5 py-3">
              <p className="text-blue-300 text-xs tracking-widest mb-0.5">CERTIFIED</p>
              <p className="text-white text-sm font-bold">出入国在留管理庁届出申請取次行政書士</p>
            </div>
          </div>

          {/* 右：特徴リスト */}
          <div className="space-y-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex items-start gap-5 pb-6 border-b border-slate-200 last:border-0 last:pb-0"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#1a3a5c] flex-shrink-0 mt-0.5">
                  <i className={`${feature.icon} text-blue-300 text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-slate-800 mb-2"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}>
                    {feature.title}
                  </h3>
                  <p className="text-slate-500 text-base leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 対応分野バナー */}
        <div className="bg-[#1a3a5c] px-10 py-8">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-shrink-0">
              <p className="text-blue-300 text-xs tracking-[0.3em] uppercase mb-1">Service Area</p>
              <p className="text-white font-bold text-lg" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                全分野対応
              </p>
            </div>
            <div className="w-px h-12 bg-white/20 hidden md:block flex-shrink-0"></div>
            <div className="flex flex-wrap gap-3">
              {['介護', '外食業', '飲食料品製造業', '建設', '農業', '漁業', '造船・舶用工業', '自動車整備', '航空', '宿泊', '素形材・産業機械・電気電子情報関連製造業', 'ビルクリーニング'].map((field) => (
                <span key={field} className="border border-white/25 text-white/80 text-xs px-3 py-1.5 tracking-wide">
                  {field}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopSection;
